import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Box, Button,IconButton, Typography } from "@mui/material";
import { ServicesSubCategory } from "src/constants";
import { priceNormalizer } from "src/utils/helpers";
import { PriceActionTypes } from "src/utils/helpers/helpers.types";

import { CloseIcon, PenMenuIcon } from "../../Icons";
import {
  setServicesDialogParams,
  showServicesDialog,
} from "../../store/reducers/dialogSlice";
import { closeDrawer } from "../../store/reducers/drawerSlice";
import { resetSelectedRow } from "../../store/reducers/tableSlice";

interface PriceListProp {
  title: string;
  priceValue: number;
}

const PriceList = ({ title, priceValue }: PriceListProp) => {
  const changedPrice = priceNormalizer(priceValue, PriceActionTypes.Showing);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "50%",
        "&:nth-of-type(1), :nth-of-type(2)": {
          margin: "0 0 24px 0",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: "400",
          color: "#828282",
          textTransform: "uppercase",
          marginBottom: "5px",
        }}
      >
        {title === "none" ? "No rank" : title}
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: "400",
        }}
      >
        {changedPrice === 0 ? "No selected" : `€ ${changedPrice.toFixed(2)}`}
      </Typography>
    </Box>
  );
};

export const RightServicesDrawer = () => {
  const dispatch = useDispatch();

  const { isShown } = useSelector((state: any) => state.drawer);
  const { selectedRow: rowData } = useSelector((state: any) => state.table);

  const handleClose = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
  };

  const getBasicEditParams = () => {
    return {
      step: 0,
      maxAvailableStep: 0,
      isEdit: true,
      data: rowData,
    };
  };

  const handleEditAllButton = () => {
    handleClose();
    setTimeout(() => {
      dispatch(setServicesDialogParams(getBasicEditParams()));
      dispatch(showServicesDialog());
    }, 100);
  };

  const handleEditInfoButton = () => {
    handleClose();
    dispatch(setServicesDialogParams(getBasicEditParams()));
    dispatch(showServicesDialog());
  };

  return (
    <Box
      sx={{
        position: "fixed",
        width: "424px",
        height: "100vh",
        minHeight: "100vh",
        overflow: 'scroll',
        zIndex: 1000,
        backgroundColor: "#F3F3F3",
        top: 82,
        right: "0px",
        display: isShown ? "block" : "none",
        transition: "right 0.3s",
        boxShadow: isShown
          ? "rgba(0, 0, 0, 0.1) -3px 10px 15px 0px"
          : undefined,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: "62px",
          backgroundColor: "white",
          padding: "10px 16px",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "6px",
            backgroundColor: "#F3F3F3",
            color: "#676767",
            fontSize: "20px",
          }}
          disableRipple
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            About service
          </Typography>
        </Box>
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "400",
          }}
          onClick={handleEditAllButton}
          disableRipple
        >
          Edit all
        </Button>
      </Box>

      <Box
        sx={{
          height: "calc(100vh - 82px - 62px)",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            margin: "16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
              Basic information
              </Typography>

              <IconButton
                onClick={handleEditInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#828282",
                  textTransform: "uppercase",
                  margin: "0 0 5px",
                }}
              >
              Service name
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {rowData.title}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            margin: "0 16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
              Service category
              </Typography>

              <IconButton
                onClick={handleEditInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    marginBottom: "5px",
                  }}
                >
                Category
                </Typography>

                {rowData.category ?
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                      overflow: "hidden",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }}
                  >
                    {rowData.category.title}
                  </Typography>
                  : (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                  Not selected
                    </Typography>
                  )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    marginBottom: "5px",
                  }}
                >
                Subcategory
                </Typography>
                {rowData.subCategory ?
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  >
                    {rowData.subCategory.title}
                  </Typography>
                  : (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                  Not selected
                    </Typography>
                  )}
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            margin: "0 16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
              Price
              </Typography>

              <IconButton
                onClick={handleEditInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {rowData?.priceList?.map(({ rank, price }: any, index: any) => (
                <PriceList key={index} title={rank} priceValue={price} />
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            margin: "0 16px 16px",
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flex: 1,
              borderRadius: "6px",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "16px 16px 32px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
              Duration
              </Typography>

              <IconButton
                onClick={handleEditInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#828282",
                    textTransform: "uppercase",
                    marginBottom: "5px",
                  }}
                >
                Service duration
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <Typography
                    sx={{
                      marginRight: "12px",
                      fontSize: "14px",
                    }}
                  >
                    {rowData?.duration &&
                    `${+Math.floor(rowData.duration / 60)} h`}
                  </Typography>
                  <Typography sx={{ fontSize: "14px" }}>
                    {rowData?.duration &&
                    `${+Math.floor(
                      rowData.duration - +Math.floor(rowData.duration / 60) * 60
                    )} min`}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
